const targetedDbFlashInitialState = {
  isLoading: false,
  error: null,
}

export default targetedDbFlashInitialState
